import React from "react";
import LegalLayout from "@/components/solanova/LegalLayout";

const H2 = ({ children }) => (
  <h2 className="font-display text-xl md:text-2xl text-white font-light mt-10 mb-3">
    {children}
  </h2>
);

const KV = ({ k, v }) => (
  <div className="flex flex-col sm:flex-row sm:gap-6 py-1.5">
    <span className="sm:w-44 text-white/45 text-sm">{k}</span>
    <span className="text-white">{v}</span>
  </div>
);

export default function Impressum() {
  return (
    <LegalLayout title="Impressum" eyebrow="Rechtliches" testId="impressum-page">
      <p>
        Angaben gemäss Schweizerischem Obligationenrecht und Bundesgesetz gegen
        den unlauteren Wettbewerb (UWG).
      </p>

      <H2>Anbieter</H2>
      <div className="rounded-2xl border border-white/8 bg-[var(--sol-surface)] p-6 md:p-8">
        <KV k="Firma" v="Solanova GmbH" />
        <KV k="Adresse" v="Vogelherd 5, 9225 Wilen-Gottshaus, Schweiz" />
        <KV k="Telefon" v="+41 76 572 55 08" />
        <KV k="E-Mail" v="info@solanova.ch" />
        <KV k="Rechtsform" v="GmbH in Gründung" />
        <KV k="UID / MwSt." v="Nummer folgt" />
      </div>

      <H2>Vertretungsberechtigte Personen</H2>
      <div className="rounded-2xl border border-white/8 bg-[var(--sol-surface)] p-6 md:p-8">
        <KV k="Geschäftsführer" v="Ramon Schaffner" />
        <KV k="Projektleiter" v="Florian Rupp" />
      </div>

      <H2>Haftungsausschluss</H2>
      <p>
        Der Autor übernimmt keinerlei Gewähr hinsichtlich der inhaltlichen Richtigkeit,
        Genauigkeit, Aktualität, Zuverlässigkeit und Vollständigkeit der Informationen.
        Haftungsansprüche gegen den Autor wegen Schäden materieller oder immaterieller
        Art, welche aus dem Zugriff oder der Nutzung bzw. Nichtnutzung der veröffentlichten
        Informationen, durch Missbrauch der Verbindung oder durch technische Störungen
        entstanden sind, werden ausgeschlossen.
      </p>
      <p>
        Alle Angebote sind unverbindlich. Der Autor behält es sich ausdrücklich vor, Teile
        der Seiten oder das gesamte Angebot ohne gesonderte Ankündigung zu verändern, zu
        ergänzen, zu löschen oder die Veröffentlichung zeitweise oder endgültig einzustellen.
      </p>

      <H2>Haftung für Links</H2>
      <p>
        Verweise und Links auf Webseiten Dritter liegen ausserhalb unseres Verantwortungsbereichs.
        Es wird jegliche Verantwortung für solche Webseiten abgelehnt. Der Zugriff und die
        Nutzung solcher Webseiten erfolgen auf eigene Gefahr des Nutzers.
      </p>

      <H2>Urheberrechte</H2>
      <p>
        Die Urheber- und alle anderen Rechte an Inhalten, Bildern, Fotos oder anderen Dateien
        auf dieser Website gehören ausschliesslich Solanova GmbH oder den speziell genannten
        Rechtsinhabern. Für die Reproduktion jeglicher Elemente ist die schriftliche Zustimmung
        der Urheberrechtsträger im Voraus einzuholen.
      </p>
    </LegalLayout>
  );
}
